import * as lodash from 'lodash'

export function isSymplApp() {
  return lodash.endsWith(location.host, 'sympl.cm')
}

export function isTokeetApp() {
  return lodash.endsWith(location.host, 'tokeet.com')
}
